export default __webpack_public_path__ + "static/mediaNet-35c4dd74b6edb50ec073849c61b8dd2f.svg";